


































































import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from "vuex-class";
import {FormRowWings, SelectWings} from 'wings-ui-components';
import {notifySuccess, notifyError} from "@/utils/notify-helper";

@Component({components: {FormRowWings, SelectWings}})
export default class TelegramOtpSend extends Vue {

  @Getter("originators") originatorsList: any;
  @Action("getOriginators") actionGetOriginators: any;
  @Action("sendTelegramOtpMessage") actionSendMessage: any;

  form = {
    recipient: '',
    originator: '',
    otpCode: '',
    callbackUrl: '',
    ttl: 120,
  }

  validationErrors: any = {}
  sending = false

  async created() {
    try {
      await this.actionGetOriginators({transport: 'Telegram OTP'})
    } catch(error) {
      notifyError(error);
    }
  }

  validate(): boolean {
    const errors: any = {}
    if (!this.form.recipient.trim()) {
      errors.recipient = this.$t('telegram_otp_send.field_required')
    }
    if (!this.form.otpCode.trim()) {
      errors.otpCode = this.$t('telegram_otp_send.field_required')
    } else if (!/^\d{4,8}$/.test(this.form.otpCode.trim())) {
      errors.otpCode = this.$t('telegram_otp_send.otp_code_invalid')
    }
    this.validationErrors = errors
    return Object.keys(errors).length === 0
  }

  async send() {
    if (!this.validate()) return
    this.sending = true
    try {
      await this.actionSendMessage(this.form)
      notifySuccess(this.$t('telegram_otp_send.success').toString())
      this.form.otpCode = ''
      this.validationErrors = {}
    } catch(error) {
      notifyError(error)
    } finally {
      this.sending = false
    }
  }
}
